import ioQuery = require("dojo/io-query");
import Component, { middlewares, newStore } from "../../../Component";
import Panel, { PanelState, reducers } from "./Panel";
import { SHOW_IN_VIEWER, SHOW_FULLSCREEN, VIEWER_CHANGE } from "./Panel/_actions";
import { push } from "../_actions";
import { MinimalGalleryState } from "..";
import supportedItemTypes from "../_utilities/supportedItemTypes";

const { addListener } = middlewares;

interface ComponentState {
    itemPages: __Component.Pojo[][];
}

export default class Gallery extends Component<MinimalGalleryState, ComponentState> {
    constructor(props: __Component.Props) {
        super(props);

        const itemsPerPage = this.props.base.applicationBaseResult.config.itemsPerPage;
        this.state = {
            itemPages: splitToPages(this.props.items.filteredItems, itemsPerPage)
        };

        this.mapItemsToChildren = this.mapItemsToChildren.bind(this);
        this.handleChildUpdate = this.handleChildUpdate.bind(this);
        this.showInViewer = this.showInViewer.bind(this);
    }

    public render() {
        const tsx = this.tsx;

        if (this.props.viewer.fullscreen) {
            return null;
        }

        return (
            <div
                class="grid-container padding-leader-1 full-width-grid-container"
                style={`background-color: ${this.props.base.applicationBaseResult.config.bgColor};`}
            >
                <div class="column-24 full-width-grid">
                    <div class="padding-leader-1 block-group block-group-5-up tablet-block-group-3-up phone-block-group-1-up">
                        {this.mapItemsToChildren()}
                    </div>
                </div>
            </div>
        );
    }

    public componentWillReceiveProps(nextProps: MinimalGalleryState) {
        if (nextProps.items.displayKey !== this.props.items.displayKey) {
            const itemsPerPage = this.props.base.applicationBaseResult.config.itemsPerPage;
            this.setState({
                itemPages: splitToPages(nextProps.items.filteredItems, itemsPerPage)
            });
        }

        if (nextProps.router.hash !== this.props.router.hash) {
            const currentViewer = ioQuery.queryToObject(this.props.router.hash).viewer;
            const nextViewer = ioQuery.queryToObject(nextProps.router.hash).viewer;
            if (currentViewer !== nextViewer) {
                for (let child in this.childComponents) {
                    if (this.childComponents.hasOwnProperty(child)) {
                        this.childComponents[child].store.dispatch({
                            type: VIEWER_CHANGE,
                            payload: nextViewer
                        });
                    }
                }
            }
        }
    }

    private mapItemsToChildren() {
        const tsx = this.tsx;

        const displayItems = this.state.itemPages[this.props.page - 1];

        this.childComponents = displayItems.reduce((result: __Component.Pojo, item: __Component.Pojo) => {
            if (this.childComponents[item.id]) {
                result[item.id] = this.childComponents[item.id];
            }
            return result;
        }, {});
        
        return displayItems.map(
            (item) => {
                // check if logged in
                const portalUrl = !!item.portal.credential ? item.portal.url : `https://${item.portal.portalHostname}`;
                if (item.type === "Dashboard") {
                    item.url = `${portalUrl}/apps/opsdashboard/index.html#/${item.id}`;
                } 
                if (item.type === "Web Experience" && item.typeKeywords.includes("status: Published")) {
                    const portal: string = item.portal.portalHostname;
                    const base = portal.indexOf("devext.arcgis.com") !== -1 ?
                                    "https://experiencedev.arcgis.com/experience/" :
                                    portal.indexOf("qaext.arcgis.com") !== -1 ?
                                        "https://experienceqa.arcgis.com/experience/" :
                                        "https://experience.arcgis.com/experience/";
                    item.url = base + item.id;
                }
                if (item.url && item.url.indexOf("/") === 0) {
                    // need to insert base url 
                    item.url = `${portalUrl}${item.url}`
                }
                const store = newStore({
                    reducers,
                    initialState: {
                        applicationBaseResult: this.props.base.applicationBaseResult,
                        i18n: this.props.base.i18n,
                        item,
                        itemType: supportedItemTypes[item.type],
                        portal: this.props.base.applicationBase.portal
                    },
                    middlewares: [ addListener(this.handleChildUpdate) ],
                    parentWidget: this.store.parentWidget
                })
                return (
                    <Panel
                        key={item.id}
                        store={store}
                    />
                );
            }
        );
    }

    private handleChildUpdate(action: { type: string, payload?: any }, childState: PanelState) {
        switch (action.type) {
            case SHOW_IN_VIEWER:
                this.showInViewer(childState.item.id);
                break;
            case SHOW_FULLSCREEN:
                this.showFullscreen(childState.item.id);
                break;
            default: //
        }
    }

    private showInViewer(itemId: string) {
        const { hash } = this.props.router;
        const hashParams = ioQuery.queryToObject(hash);
        hashParams.viewer = itemId;
        this.dispatch(push(ioQuery.objectToQuery(hashParams)));
    }

    private showFullscreen(itemId: string) {
        const { hash } = this.props.router;
        const hashParams = ioQuery.queryToObject(hash);
        hashParams.viewer = itemId;
        hashParams.fullscreen = true;
        this.dispatch(push(ioQuery.objectToQuery(hashParams)));
    }
}

function splitToPages(items: __Component.Pojo, perPage: number) {
    return items.reduce((result: __Component.Pojo[][], item: __Component.Pojo) => {
        if (result[result.length - 1].length < perPage) {
            result[result.length - 1].push(item);
        } else {
            result.push([item]);
        }
        return result;
    }, [[]]);
}



// WEBPACK FOOTER //
// ./src/mainApp/MinimalGallery/Gallery/index.tsx